module.exports = "<div class=\"education\">\r\n  <!--<router-outlet></router-outlet>-->\r\n  <div class=\"banner\">\r\n    <img src=\"../../../../assets/img/education/banner.jpg\" [alt]=\"'education.banner-alt' | translate\">\r\n  </div>\r\n  <app-evaluation [evaluation]=\"'education.evaluation' | translate\"></app-evaluation>\r\n  <app-prod-system></app-prod-system>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// C:/Users/anach/Desktop/tengtu-website/src/app/components/education/education-main/education-main.component.html
// module id = ../../../../../src/app/components/education/education-main/education-main.component.html
// module chunks = main